// Dependencies
import { Component } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import DropList from 'components/atoms/DropList';
import FormGroup from 'components/atoms/FormGroup';
import { DRAWING_MODES } from 'data/static';
import { bindActionCreators, Dispatch } from 'redux';
import {
    SetErrorHandlerAction,
    setErrorHandlerAction,
    setSystemLoadingAction,
    SetSystemLoadingAction,
    showMessageAction,
    ShowMessageAction,
} from 'store/actions/errorsActions';
import {
    SetLayoutAction,
    setLayoutAction,
    SetMenuControlsAction,
    setMenuControlsAction,
} from 'store/actions/layoutActions';
import { Layout, OpenModal, PortType, RootState } from 'types';
import { MapControlsInterface, SearchControlsInterface } from 'types/functions';
import { GeoJSONFeatureCollection } from 'types/geojson';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { checkDifferent, clone } from 'utils/formHandlers';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

interface DrawingMenuComponentProps {
    active: boolean;

    port: PortType;
    setLayoutAction: SetLayoutAction;
    setErrorHandlerAction: SetErrorHandlerAction;
    setSystemLoadingAction: SetSystemLoadingAction;
    searchControls: SearchControlsInterface;
    openModelFunction: OpenModal;
    dateTimeFormat: DateTimeFormat;
    mode: string;
    setMenuControlsAction: SetMenuControlsAction;
    mapControls: MapControlsInterface;
    showMessageAction: ShowMessageAction;
    layout: Layout;
}

interface DrawingMenuComponentState {
    active: boolean;
    layout: Layout;
    mode: string;
    drawingMode: { chart: string; time: string; playback: string };
}

class DrawingMenu extends Component<DrawingMenuComponentProps, DrawingMenuComponentState> {
    constructor(props: DrawingMenuComponentProps) {
        super(props);
        this.state = {
            layout: clone(props.layout),
            active: props.active,
            mode: props.mode,
            drawingMode: { chart: 'pointer', time: 'pointer', playback: 'pointer' },
        };
    }

    static getDerivedStateFromProps(props: DrawingMenuComponentProps, state: DrawingMenuComponentState) {
        if (props.active !== state.active) {
            return { active: props.active };
        }

        if (props.mode !== state.mode) {
            return { mode: props.mode };
        }

        if (checkDifferent(props.layout, state.layout)) {
            return {
                layout: props.layout,
            };
        }
        return null;
    }

    componentDidMount(): void {
        this.props.setMenuControlsAction({
            drawing: {
                setDrawingMode: (mode) => {
                    this.handleChangeMode('mode', mode);
                },
                getMode: (mode) => {
                    return this.state.drawingMode[mode];
                },
            },
        });
    }

    handleChangeMode = (name: string, value: string) => {
        //@ts-ignore
        this.setState((prevState) => {
            // Call mapControls after setState
            setTimeout(() => {
                switch (this.props.mode) {
                    case 'live':
                    case 'time':
                        this.props.mapControls.time?.setDrawingMode(value);
                        break;
                    case 'playback':
                        this.props.mapControls.playback?.setDrawingMode(value);
                        break;
                    case 'search':
                        this.props.mapControls.chart?.setDrawingMode(value);
                        break;
                    default:
                        break;
                }
            });
            const mode = this.getRelatedMode();
            return {
                drawingMode: {
                    ...prevState.drawingMode,
                    //@ts-ignore
                    [mode]: value,
                },
            };
        });
    };

    getRelatedMode = () => {
        switch (this.props.mode) {
            case 'live':
            case 'time':
                return 'time';
            case 'playback':
                return 'playback';
            case 'search':
                return 'chart';
            default:
                break;
        }
    };

    downloadDrawingData = () => {
        let featureCollection: GeoJSONFeatureCollection | undefined = { type: 'FeatureCollection', features: [] };

        switch (this.props.mode) {
            case 'live':
            case 'time':
                featureCollection = this.props.mapControls.time?.getDrawingFeatures();
                break;
            case 'playback':
                featureCollection = this.props.mapControls.playback?.getDrawingFeatures();
                break;
            case 'search':
                featureCollection = this.props.mapControls.chart?.getDrawingFeatures();
                break;
            default:
                break;
        }

        const dataStr = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(featureCollection))}`;
        const downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute('href', dataStr);
        downloadAnchorNode.setAttribute('download', 'drawingLine.json');
        document.body.appendChild(downloadAnchorNode); // required for firefox
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
    };

    render() {
        return (
            <div
                className={twclsx(
                    this.state.active ? 'left-0 ' : 'left-out',
                    'mt-14',
                    'h-page',
                    'border-r',
                    'border-gray-300',
                    'position-transition',
                    'fixed',
                    'z-20',
                    'w-menu',
                    'ml-14',
                    'h-page',
                    'top-0',
                    'bg-white'
                )}
            >
                <div className="flex justify-between border-b border-gray-300 py-3  px-2">
                    <div className="text-lg font-bold">{translate('Drawing')}</div>
                    {/*hash close menu 'x'*/}
                    {/* <div
                        onClick={() => {
                            this.props.setLayoutAction([
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'drawing',
                                        section: 'playback',
                                        state: false,
                                    },
                                },
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'drawing',
                                        section: 'time',
                                        state: false,
                                    },
                                },
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'drawing',
                                        section: 'chart',
                                        state: false,
                                    },
                                },
                            ]);
                        }}
                        className="cursor-pointer"
                    >
                        <Icon>
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M18 6l-12 12" />
                            <path d="M6 6l12 12" />
                        </Icon>
                    </div> */}
                </div>

                <Scrollbars
                    className={twclsx('h-menuFull', 'w-full', 'pr-1')}
                    renderThumbVertical={({ style, ...props }) => (
                        <div
                            {...props}
                            style={{
                                ...style,
                                background: '#0000004a',
                                borderRadius: 5,
                                zIndex: 10, // Custom z-index
                                position: 'relative', // Required for z-index to work
                            }}
                        />
                    )}
                    style={{ height: 'auto', zIndex: 10 }}
                >
                    <div className="mx-2 flex  flex-col gap-1">
                        <FormGroup label={translate('drawing mode')}></FormGroup>
                        <DropList  capitalize
                            name="drawingMode"
                            id="drawingMode"
                            //@ts-ignore
                            value={this.state.drawingMode[this.getRelatedMode()]}
                            options={Object.keys(DRAWING_MODES)
                                .filter((x) => {
                                    return !x.includes('measure') && x !== 'pointer';
                                })
                                .map((x) => {
                                    return { value: x, label: translate(DRAWING_MODES[x].text) };
                                })}
                            onChange={this.handleChangeMode}
                        ></DropList>
                    </div>
                </Scrollbars>

                <div className="h-10 pt-1 mx-3 flex justify-between">
                    <Button
                        type="button"
                        onClick={this.downloadDrawingData}
                        className={twclsx(
                            'px-4',
                            'h-8',
                            'w-20',
                            'bg-primary-300 ',
                            'rounded-md',
                            'px-3',
                            'rounded',
                            'text-white'
                        )}
                    >
                        {translate('Export ')}
                    </Button>
                </div>
            </div>
        );
    }
}

const drawingMenuStateToProps = (state: RootState) => ({
    port: state.port.port,
    searchControls: state.layout.searchControls,
    openModelFunction: state.layout.openModelFunction,
    dateTimeFormat: state.port.dateTimeFormat,
    mode: state.layout.mode,
    mapControls: state.map.mapControls,
    layout: state.layout.layout,
});

const drawingMenuDispatchToProps = (dispatch: Dispatch) => ({
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
    setSystemLoadingAction: bindActionCreators(setSystemLoadingAction, dispatch),
    setMenuControlsAction: bindActionCreators(setMenuControlsAction, dispatch),
    showMessageAction: bindActionCreators(showMessageAction, dispatch),
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
});

export default connect(drawingMenuStateToProps, drawingMenuDispatchToProps)(DrawingMenu);
